import { useMemo } from 'react';

export const useMinValidationDate = () => {
  const minValidationDate = useMemo(() => new Date(), []);

  return { minValidationDate };
};
